import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from '../base-next';

const FirstNameNext = props => {
  const { onChange, value, error, touched, onBlur, isDisabled } = props;
  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="firstName"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      id="first"
      type="text"
      labelText="First Name"
      inputTip="enter exactly as it appears on your driver's license"
      maxLength={31}
    />
  );
};

FirstNameNext.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  touched: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDisabled: PropTypes.bool
};

FirstNameNext.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  touched: false,
  error: false,
  isDisabled: false
};

export default FirstNameNext;
